export type DevLogCategory = "기능" | "데이터연동" | "인프라" | "보안" | "성능" | "운영";

export interface DevLogEntry {
  date: string; // YYYY-MM-DD
  category: DevLogCategory;
  title: string;
  summary?: string;
}

/**
 * 강스터디 개발 현황 기록.
 * 오래된 순 → 최신순으로 정렬되어 있다. 작업이 끝나면 배열 맨 끝에 새 항목을 추가한다.
 * (관리자 화면에서는 최신순으로 뒤집어 보여준다.)
 */
export const devLog: DevLogEntry[] = [
  { date: "2026-05-27", category: "기능", title: "메인 페이지 완성", summary: "히어로, 오늘의 추천 경매물건, 강의과정, 리포트, 상담신청 CTA, 수강후기, 푸터." },
  { date: "2026-05-27", category: "기능", title: "경매물건 목록·상세 페이지", summary: "필터·검색 포함." },
  { date: "2026-05-27", category: "기능", title: "교육과정·동영상 강의 페이지" },
  { date: "2026-05-27", category: "기능", title: "상담신청·리포트 구매 페이지" },
  { date: "2026-05-27", category: "기능", title: "로그인·회원가입 페이지" },
  { date: "2026-05-27", category: "기능", title: "마이페이지·커뮤니티 페이지(UI)", summary: "공지사항·질문게시판·후기게시판 구조." },
  { date: "2026-05-27", category: "기능", title: "관리자 대시보드", summary: "회원·교육·결제·물건·상담·알림·통계 관리." },
  { date: "2026-06-03", category: "기능", title: "데이터 모델 뼈대 구축", summary: "TypeScript 타입 정의 + 목업 데이터(User·AuctionItem·Application)." },
  { date: "2026-07-28", category: "기능", title: "자동 블로그 시스템", summary: "템플릿 기반 자동 생성(AI API 불필요), pg_cron으로 매일 07:00 실행." },
  { date: "2026-07-28", category: "기능", title: "AI 투자 시뮬레이터", summary: "5단계 연산 엔진 + AI 100점 점수 엔진." },
  { date: "2026-08-03", category: "기능", title: "낙찰물건 인사이트 & \"전문가 PICK\" 리브랜딩", summary: "사후 분석 데이터로 교육 자료화, 경매물건 상세와 연동." },
  { date: "2026-08-07", category: "기능", title: "경매 입찰가 계산기", summary: "일반방식(비용차감형) + 시세역산방식(Top-Down) 듀얼 모드." },
  { date: "2026-08-18", category: "인프라", title: "강스터디 프론트 이관", summary: "Readdy 제작본을 독립 Vite 앱으로 분리, EchoTwin과 Supabase 프로젝트 통합, RLS 재작성(쓰기는 service_role 전용), admin 쓰기 대행 Edge Function 도입." },
  { date: "2026-08-18", category: "인프라", title: "pg_cron 이관 + 하드코딩 인증 시크릿 제거", summary: "고정 문자열로 폴백하던 CRON_SECRET을 fail-closed로 전환." },
  { date: "2026-08-18", category: "데이터연동", title: "자료실(materials) 테이블·버킷 보정", summary: "다운로드 카운터를 RPC로 분리, 파일 업로드는 서명 URL 방식." },
  { date: "2026-08-18", category: "인프라", title: "전 테이블·버킷에 kangstudy_ 접두사 개명", summary: "공유 Supabase 프로젝트에서 EchoTwin 테이블과 오인 방지." },
  { date: "2026-08-18", category: "운영", title: "개명 여파 복구", summary: "테이블 rename을 따라가지 못한 함수 본문 3곳 재생성." },
  { date: "2026-08-18", category: "데이터연동", title: "\"전문가 PICK\"을 EchoTwin 실데이터로 전환", summary: "auction_cases 49,816건에서 매일 06:30 60건 자동 큐레이션." },
  { date: "2026-08-18", category: "기능", title: "AI 경매비서(챗봇) 복구", summary: "Pages Function 프록시로 Gemini 키 비노출 + 호출 제한." },
  { date: "2026-08-18", category: "인프라", title: "커스텀 도메인 study.echotwin.kr 연결" },
  { date: "2026-08-18", category: "보안", title: "챗봇 전역 일일 호출 상한(200/일) + 진단 프로브 추가" },
  { date: "2026-08-18", category: "성능", title: "이미지 전량 R2 이관", summary: "readdy.ai 의존 제거, 자체 CDN(img.echotwin.kr)으로 전환." },
  { date: "2026-08-18", category: "보안", title: "폼 5종을 자체 DB로 이관", summary: "readdy.ai form API 의존·고객 PII 외부 유출 위험 제거." },
  { date: "2026-08-18", category: "기능", title: "관리자 폼 접수함 오픈", summary: "제출된 신청 열람 화면 신설(상담·교육신청·리포트·뉴스레터·강의문의)." },
  { date: "2026-08-18", category: "운영", title: "수기 샘플·표본 데이터 정리" },
  { date: "2026-08-18", category: "운영", title: "챗봇 API 키 교체", summary: "소유권 불명 키 폐기, 사용자 계정 키로 전환." },
  { date: "2026-08-18", category: "성능", title: "/reports 이미지 최적화", summary: "84% 경량화(60MB→9.8MB) + lazy 로딩으로 로딩 지연 해소." },
  { date: "2026-08-18", category: "운영", title: "kangstudy-web 저장소 분리", summary: "외부 개발자 인수인계, 온보딩 README 작성." },
  { date: "2026-08-18", category: "데이터연동", title: "EchoTwin API worker 연동", summary: "매물 상세·분석 전체를 가공·인증 후 안전하게 공급." },
  { date: "2026-08-18", category: "데이터연동", title: "교육·커뮤니티 실연동", summary: "목업 → Supabase DB(kangstudy_courses, kangstudy_posts 등)." },
  { date: "2026-08-18", category: "기능", title: "제품 PRD 문서 작성", summary: "앱 내 /prd 페이지 — 전 페이지 실연동 상태·아키텍처·로드맵 정리." },
  { date: "2026-08-18", category: "기능", title: "관리자 \"개발현황\" 메뉴 추가", summary: "이 기록 자체 — 앞으로 작업 끝날 때마다 여기에 이어서 기록한다." },
];
